"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AppModule () {
        return AppModule;
    },
    get ceModuleConfig () {
        return ceModuleConfig;
    }
});
const _common = require("@nestjs/common");
const _core = require("@nestjs/core");
const _config = require("@nestjs/config");
const _eventemitter = require("@nestjs/event-emitter");
const _setup = require("@sentry/nestjs/setup");
const _nocomodule = require("~/modules/noco.module");
const _authmodule = require("~/modules/auth/auth.module");
const _globalexceptionfilter = require("~/filters/global-exception/global-exception.filter");
const _globalmiddleware = require("~/middlewares/global/global.middleware");
const _guimiddleware = require("~/middlewares/gui/gui.middleware");
const _eventemittermodule = require("~/modules/event-emitter/event-emitter.module");
const _jobsmodule = require("~/modules/jobs/jobs.module");
const _appconfig = /*#__PURE__*/ _interop_require_default(require("~/app.config"));
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _rawbodymiddleware = require("~/middlewares/raw-body.middleware");
const _jsonbodymiddleware = require("~/middlewares/json-body.middleware");
const _urlencodemiddleware = require("~/middlewares/url-encode.middleware");
const _oauthmodule = require("~/modules/oauth/oauth.module");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
const ceModuleConfig = {
    imports: [
        _authmodule.AuthModule,
        _oauthmodule.OAuthModule,
        _nocomodule.NocoModule,
        _eventemittermodule.EventEmitterModule,
        _jobsmodule.JobsModule,
        _eventemitter.EventEmitterModule.forRoot(),
        _config.ConfigModule.forRoot({
            load: [
                ()=>_appconfig.default
            ],
            isGlobal: true
        }),
        ...process.env.NC_SENTRY_DSN ? [
            _setup.SentryModule.forRoot()
        ] : []
    ],
    providers: [
        {
            provide: _core.APP_FILTER,
            useClass: _globalexceptionfilter.GlobalExceptionFilter
        },
        {
            provide: _core.APP_GUARD,
            useClass: _extractidsmiddleware.ExtractIdsMiddleware
        }
    ]
};
let AppModule = class AppModule {
    // Global Middleware
    configure(consumer) {
        var _process_env_NC_DASHBOARD_URL;
        const dashboardPath = (_process_env_NC_DASHBOARD_URL = process.env.NC_DASHBOARD_URL) != null ? _process_env_NC_DASHBOARD_URL : '/dashboard';
        consumer.apply(_rawbodymiddleware.RawBodyMiddleware).forRoutes({
            path: '/api/payment/webhook',
            method: _common.RequestMethod.POST
        }).apply(_jsonbodymiddleware.JsonBodyMiddleware).forRoutes('*').apply(_urlencodemiddleware.UrlEncodeMiddleware).forRoutes('*').apply(_guimiddleware.GuiMiddleware).forRoutes({
            path: `${dashboardPath}*`,
            method: _common.RequestMethod.GET
        }).apply(_globalmiddleware.GlobalMiddleware).forRoutes({
            path: '*',
            method: _common.RequestMethod.ALL
        });
    }
};
AppModule = _ts_decorate([
    (0, _common.Module)(ceModuleConfig)
], AppModule);
